interface IPlayerFiltersData {
    sortByFilters: string[];
    performanceFilters: string[];
    attributesFilters: string[];
}

const playerFilterData: IPlayerFiltersData = {
    sortByFilters: [
        "Similarity",
        "Age",
        "Total mins played",
        "True value",
        "Market value",
        //"Wages",
        "Appearances",
        "Contract left",
    ],
    performanceFilters: [
        "Contribution value",
        "System fit",
    ],
    attributesFilters: [
        // "Performance value",
        "Finishing - Shots",
        "Finishing - Aerial",
        "Attack positioning",
        "Creativity",
        "Passing accuracy",
        "Dribbling",
        "Crossing",
        "Tackling",
        "Defensive headers",
        "Aggression",
        // "Speed",
        // "Strength",
        // "Work rate",
        // "Fitness",
    ],
};


export default playerFilterData;